import { Colors, HTMLTable } from "@blueprintjs/core";
import styled from "styled-components";
const CustomTable = styled(HTMLTable)<{
  isStickyFirstColumn?: boolean;
  firstColumnWidth?: string;
}>`
  overflow-x: scroll;
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  th {
    font-weight: 600;
  }
  tbody {
    tr {
      &:hover {
        background-color: ${({ theme: { darkMode } }) =>
          darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY5};
      }
      border-bottom: 1px solid
        ${({ theme: { darkMode } }) =>
          darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY2};
      &:last-child {
        border-bottom: none;
      }
    }
    td {
      vertical-align: middle;
      padding: 6px 10px;
    }
  }
  td,
  th {
    white-space: nowrap;
    color: ${({ theme: { darkMode } }) =>
      darkMode ? Colors.GRAY3 : Colors.GRAY1} !important;
    ${({ isStickyFirstColumn, theme: { darkMode }, firstColumnWidth }) =>
      isStickyFirstColumn &&
      `
      &:first-child {
        width:${firstColumnWidth || "250px"};
        position: -webkit-sticky;
        position: sticky;
        left: 0;
        float: left;
        padding-left: 10px;
        background-color: ${darkMode ? Colors.DARK_GRAY2 : Colors.WHITE};
        z-index: 2;
        border-right: 1px solid ${
          darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY2
        };
        &:hover {
          background-color: ${darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY5};
        }
      }
    `}
  }

  th {
    ${({ isStickyFirstColumn }) =>
      isStickyFirstColumn &&
      `
      &:first-child {
        &:hover {
            background-color: transparent;
            }
     }`}
  }
`;

export default CustomTable;
